import withCreateUpdateLinkForm from "../../../HOC/withCreateUpdateLinkForm"
import CreateUpdateNewLinkFormView from "./CreateUpdateNewLinkFormView/CreateUpdateNewLinkFormView"



export default function CreateUpdateNewLinkFormPresenter({isUpdate}:{isUpdate?: boolean}) {
  const Form = withCreateUpdateLinkForm(isUpdate || false, CreateUpdateNewLinkFormView)
  return <Form />
}
